import { DateRange } from '../DateRange/DateRange';
import { MicroDateInput } from '../MicroDateInput/MicroDateInput';
import { MicroDateRangeProvider } from './MicroDateRangeProvider';
import { jsx as _jsx } from "react/jsx-runtime";
export const MicroDateRange = props => {
  return /*#__PURE__*/_jsx(MicroDateRangeProvider, {
    wrapperStyleOverrides: {
      display: 'inline-flex'
    },
    children: /*#__PURE__*/_jsx(DateRange, Object.assign({}, props, {
      DateInput: MicroDateInput
    }))
  });
};